import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

import { z } from 'zod'
import { localizeInternalPath } from '@/shared/i18n/localized-path'

export const Route = createFileRoute('/$lang/auth/')({
  validateSearch: z.object({
    redirect: z.string().optional().catch(''),
  }),
  beforeLoad: ({ context, search, params }) => {
    if (context.auth.status === 'AUTHENTICATED') {
      const redirectTo = localizeInternalPath(search.redirect, params.lang)
      if (redirectTo) {
        throw redirect({ href: redirectTo })
      }

      throw redirect({
        to: '/$lang/app',
        params: { lang: params.lang },
      })
    }

    throw redirect({
      to: '/$lang/login',
      params: { lang: params.lang },
    })
  },
  component: AuthLayout,
  staticData: { layout: 'public' },
})

function AuthLayout() {
  return (
    <div className="p-2 h-full">
      <Outlet />
    </div>
  )
}
